import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const PermutationIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M4 9.3252V9.3352M4 4.3252V4.3352M9 4.3252V4.3352M15 4.3252V4.3352M15 20.3252V20.3352M20 4.3252V4.3352M20 9.3252V9.3352M20 15.3252V15.3352M20 20.3252V20.3352M5 13.3252H10C10.2652 13.3252 10.5196 13.4306 10.7071 13.6181C10.8946 13.8056 11 14.06 11 14.3252V19.3252C11 19.5904 10.8946 19.8448 10.7071 20.0323C10.5196 20.2198 10.2652 20.3252 10 20.3252H5C4.73478 20.3252 4.48043 20.2198 4.29289 20.0323C4.10536 19.8448 4 19.5904 4 19.3252V14.3252C4 14.06 4.10536 13.8056 4.29289 13.6181C4.48043 13.4306 4.73478 13.3252 5 13.3252Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(PermutationIcon);
